import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  root: {
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    border: '0.5px solid #aaaaaa',
    height: '40px',
    fontSize: '14px',
    outline: 'none',
    borderRadius: '4px',
  },
  input: {
    width: '100%',
    flexGrow: '1',
    border: 'none',
    outline: 'none',
  },
}));
